import type { CSSProperties } from 'react'

import { loadingI18n } from '../../i18n/shared/loading'
import { useLocaleStore } from '../../store/locale'

const surfaceStyle: CSSProperties = {
  alignItems: 'center',
  background: 'var(--color-porcelain)',
  display: 'flex',
  flexDirection: 'column',
  inset: 0,
  justifyContent: 'center',
  position: 'fixed',
}

type BootstrapErrorProps = {
  onRetry?: () => void
}

export function BootstrapError({
  onRetry = () => window.location.reload(),
}: BootstrapErrorProps) {
  const locale = useLocaleStore((state) => state.locale)
  const copy = loadingI18n[locale]

  return (
    <div data-bootstrap-error-surface style={surfaceStyle}>
      <p
        role="alert"
        style={{
          color: 'var(--color-ink)',
          fontSize: '1rem',
          fontWeight: 600,
          margin: '0 0 var(--space-4)',
        }}
      >
        {copy.startupError}
      </p>
      <button
        onClick={onRetry}
        style={{
          background: 'var(--color-ink)',
          border: 0,
          borderRadius: 'var(--radius-control)',
          color: 'var(--color-porcelain)',
          cursor: 'pointer',
          font: 'inherit',
          fontWeight: 600,
          minHeight: '2.75rem',
          padding: '0 var(--space-5)',
        }}
        type="button"
      >
        {copy.retry}
      </button>
    </div>
  )
}
